export const setLevel = (filter: any) => ({
    type: 'SET_LEVEL',
    payload: filter,
  });